import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function LoginPage() {
  const [mensaje, setMensaje] = useState('');
  const [cargando, setCargando] = useState(false);
  const navigate = useNavigate();
  const query = useQuery();

  const BACKEND_URL = process.env.NODE_ENV === 'production' 
    ? 'https://biofirmabk.colombianadetrasplantes.com'
    : 'http://localhost:3001';

  useEffect(() => {
    const yaLogueado = localStorage.getItem('correo') && localStorage.getItem('rol');
    if (yaLogueado) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const procesarLogin = () => {
      const correo = query.get('correo');
      const nombresRaw = query.get('nombres');
      const rol = query.get('rol');
      const permisosRaw = query.get('permisos');
      const firmaRaw = query.get('firma'); // ⬅️ NUEVO: recibir firma
      const userId = query.get('id'); // ⬅️ NUEVO: recibir ID
      const error = query.get('error');
      const success = query.get('success');

      if (error) {
        setCargando(false);
        switch (error) {
          case 'blocked':
            setMensaje('🔒 Tu cuenta está bloqueada. Contacta al administrador para desbloquearla.');
            break;
          case 'user_not_found':
            setMensaje('⚠️ Usuario no encontrado en el sistema. Contacta al administrador.');
            break;
          case 'user_inactive':
            setMensaje('⚠️ Tu cuenta está inactiva. Contacta al administrador.');
            break;
          case 'auth_failed':
            setMensaje('❌ Error en la autenticación con Microsoft. Intenta nuevamente.');
            break;
          case 'server_error':
            setMensaje('❌ Error del servidor. Intenta nuevamente en unos minutos.');
            break;
          case 'domain_not_allowed':
            setMensaje('❌ Solo usuarios del dominio @colombianadetrasplantes.com pueden acceder.');
            break;
          case 'no_email':
            setMensaje('❌ No se pudo obtener el correo de Microsoft. Intenta nuevamente.');
            break;
          default:
            setMensaje(`❌ Error: ${error}. Contacta al soporte técnico.`);
        }
        return;
      }

      if (correo && nombresRaw && rol && success === 'true') {
        setCargando(true);
        setMensaje('✅ Inicio de sesión exitoso. Redirigiendo...');

        // ⭐ DECODIFICAR NOMBRE COMPLETO (con tildes y espacios)
        const nombres = decodeURIComponent(nombresRaw);

        // ⭐ DECODIFICAR PERMISOS
        let permisos = null;
        if (permisosRaw) {
          try {
            permisos = JSON.parse(decodeURIComponent(permisosRaw));
          } catch (error) {
            console.warn('Error al decodificar permisos:', error);
            permisos = permisosRaw;
          }
        }

        // ⭐ DECODIFICAR FIRMA (si viene)
        const firma = firmaRaw ? decodeURIComponent(firmaRaw) : null;

        // ✅ GUARDAR DATOS DE SESIÓN EN LOCALSTORAGE
        localStorage.setItem('id', userId || ''); 
        localStorage.setItem('correo', correo);
        localStorage.setItem('nombres', nombres);
        localStorage.setItem('rol', rol);

        if (permisos) {
          localStorage.setItem('permisos', typeof permisos === 'string' ? permisos : JSON.stringify(permisos));
        }

        // ⬅️ NUEVO: Guardar firma si existe
        if (firma && firma !== 'null') {
          localStorage.setItem('firma', firma);
        }

        // ✅ GUARDAR DATOS DE SESIÓN EN LOCALSTORAGE
        localStorage.setItem('id', userId || '');
        localStorage.setItem('correo', correo);
        localStorage.setItem('nombres', nombres);
        localStorage.setItem('rol', rol);

        if (permisos) {
          localStorage.setItem('permisos', typeof permisos === 'string' ? permisos : JSON.stringify(permisos));
        }

        // Guardar firma si existe
        if (firma && firma !== 'null') {
          localStorage.setItem('firma', firma);
        }

        // ⭐ NUEVO: Guardar tipo y número de documento
        const tipoDocumentoRaw = query.get('tipoDocumento');
        const numeroDocumentoRaw = query.get('numeroDocumento');
        
        if (tipoDocumentoRaw && tipoDocumentoRaw !== 'null') {
          localStorage.setItem('tipoDocumento', tipoDocumentoRaw);
        }
        
        if (numeroDocumentoRaw && numeroDocumentoRaw !== 'null') {
          localStorage.setItem('numeroDocumento', numeroDocumentoRaw);
        }

        console.log('✅ Sesión guardada:', {
          id: userId,
          nombres: nombres,
          correo: correo,
          rol: rol,
          tieneFirma: !!firma
        });

        // Redirigir al dashboard
        setTimeout(() => navigate('/dashboard'), 1200);
      }
    };

    procesarLogin();
  }, [query, navigate]);

  const loginConMicrosoft = () => {
    setMensaje('🔄 Redirigiendo a Microsoft...');
    window.location.href = `${BACKEND_URL}/auth/microsoft`;
  };

  return (
    <div className="d-flex justify-content-center align-items-center flex-column" style={{ minHeight: '100vh', backgroundColor: '#f4f6f8' }}>
      <div className="text-center mb-4">
        <h1 style={{ color: '#1a1e4b', fontSize: '2.2rem', fontWeight: 'bold' }}>
          Bienvenido a BIOFIRMAS-CTX
        </h1>
      </div>

      <div className="text-center mb-4">
        <img src="/logo2.png" alt="Logo Empresa" style={{ width: '200px', height: 'auto', marginBottom: '20px' }} />
        <img src="/logo1.png" alt="Logo Proyecto" style={{ width: '150px', height: '150px' }} />
      </div>

      <div className="bg-white p-4 rounded shadow" style={{ width: '350px' }}>
        <button
          type="button"
          onClick={loginConMicrosoft}
          className="btn btn-outline-dark w-100 d-flex align-items-center justify-content-center"
          style={{ padding: '12px', fontSize: '1.1rem' }}
          disabled={cargando}
        >
          {cargando ? (
            <>
              <div className="spinner-border spinner-border-sm me-3" role="status" style={{ width: '20px', height: '20px' }}></div>
              Verificando...
            </>
          ) : (
            <>
              <img
                src="https://cdn-icons-png.flaticon.com/512/732/732221.png"
                alt="Microsoft"
                width="24"
                className="me-3"
              />
              Iniciar sesión con Microsoft 365
            </>
          )}
        </button>

        {mensaje && (
          <div className="text-center mt-3">
            <p className={`fw-bold ${mensaje.includes('✅') ? 'text-success' : mensaje.includes('❌') ? 'text-danger' : 'text-primary'}`}>
              {mensaje}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default LoginPage;